import axios from "axios";

export default axios.create({
    // baseURL: "http://yazdgisheold.local/Api",
    baseURL: "https://yazdgishe.ir/Api",
    headers: {
        "Content-type": "application/json",
    }
});